import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { reportFilters } from '../../../../Reducers';

import { TypeBlock, TypeDistrict, TypeSchool } from '../../../../types';

interface IProps {
    selectedDistrict: TypeDistrict;
    setBlock: ([]) => void;
    selectedBlock: TypeBlock;
    setSelectedBlock: (e: null | TypeBlock) => void;
    changeBlockFilters: (e: TypeBlock) => void;
    setSchool: ([]) => void;
    setSelectedSchool: (e: null) => void;
    changeSchoolFilters: ({ }: TypeSchool) => void;
    fetchBlocks: () => void;
    blockFilter: boolean;
    block: TypeBlock[];
};

function BlockFilter({
    selectedDistrict,
    setBlock,
    selectedBlock,
    setSelectedBlock,
    changeBlockFilters,
    setSchool,
    setSelectedSchool,
    changeSchoolFilters,
    fetchBlocks,
    blockFilter,
    block
}: IProps) {

    // --- DROPDOWN BLOCK TYPE ---
    const [blockDropdownOpen, setBlockDropdownOpen] = useState(false);
    const blockTypeToggle = () => setBlockDropdownOpen(prevState => !prevState);

    // const [selectedBlock, setSelectedBlock] = useState<TypeBlock>(block); // stores selected block


    useEffect(() => {
        if (selectedDistrict.id) {
            setBlock([]);
            setSelectedBlock(null);
            changeBlockFilters(reportFilters.block);
            setSchool([]);
            setSelectedSchool(null);
            changeSchoolFilters(reportFilters.school);
            fetchBlocks();
        }
        console.log("------ Block component ------")
    }, [selectedDistrict.id]);

    return (
        <React.Fragment>
            {blockFilter ? <Dropdown size="sm" isOpen={blockDropdownOpen} direction="down" toggle={blockTypeToggle}>
                <DropdownToggle caret>
                    {selectedBlock ? <span>Block: <span className="text-primary text-capitalize">{selectedBlock?.name}</span></span> : 'Block: All'}
                </DropdownToggle>
                <DropdownMenu>
                    {
                        block?.length !== 0 ? block?.map((each, index) => (
                            <DropdownItem key={index} onClick={() => changeBlockFilters(each)}>
                                <span className="d-flex justify-content-between align-items-center">
                                    {each?.name}
                                    {selectedBlock?.id === each?.id && <i className="fas fa-check-circle text-primary"></i>}
                                </span>
                            </DropdownItem>
                        )) : <span className="small text-muted text-center">Select District First</span>
                    }
                </DropdownMenu>
            </Dropdown> : <></>}
        </React.Fragment>
    )
}

export default React.memo(BlockFilter);